import {useRouteLoaderData} from '@remix-run/react'
import clsx from 'clsx'
import type {FunctionComponent} from 'react'
import React from 'react'
import {BestChoiceIcon} from '~/icons/best-choice-icon'
import {HeartIcon} from '~/icons/heart-icon'
import {ThumbUpSignaturePickIcon} from '~/icons/thumb-up-signature-pick-icon'
import {ValueForMoneyIcon} from '~/icons/value-for-money-icon'
import {getTranslation} from '~/localization/translation'
import type {MultidomainProductBadge, RootLoaderResponse} from '~/types'

interface UserValueEUBadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  badge?: MultidomainProductBadge
}

const UserValueEUBadge: FunctionComponent<UserValueEUBadgeProps> = ({badge, ...attributes}) => {
  const {language} = useRouteLoaderData('root') as RootLoaderResponse
  const translations = getTranslation(language)

  switch (badge) {
    case 'bestChoice':
      return (
        <div {...attributes}>
          <div
            className={clsx(
              'z-40 flex h-9 items-center justify-center gap-2 overflow-hidden p-2 text-base font-medium',
            )}
            data-testid="product-badge-user-value-eu"
          >
            <BestChoiceIcon className="shrink-0" />
            <span className="text-[15px] font-medium">{translations.Badge.bestChoice}</span>
          </div>
        </div>
      )
    case 'valueForMoney':
      return (
        <div {...attributes}>
          <div
            className={clsx(
              'z-40 flex h-9 items-center justify-center gap-2 overflow-hidden p-2 text-base font-medium',
            )}
            data-testid="product-badge-user-value-eu"
          >
            <ValueForMoneyIcon className="shrink-0" />
            <span className={clsx('text-[15px] font-[500]')}>{translations.Badge.valueForMoney}</span>
          </div>
        </div>
      )
    case 'topRated':
      return (
        <div {...attributes}>
          <div
            className={clsx(
              'z-40 flex h-9 items-center justify-center gap-2 overflow-hidden p-2 text-base font-medium',
            )}
            data-testid="product-badge-user-value-eu"
          >
            <BestChoiceIcon className="shrink-0" />
            <span className={clsx('text-[15px] font-[500]')}>{translations.Badge.topRated}</span>
          </div>
        </div>
      )
    case 'countryTopRated':
      return (
        <div {...attributes}>
          <div
            className={clsx(
              'z-40 flex h-9 items-center justify-center gap-2 overflow-hidden p-2 text-base font-medium',
            )}
            data-testid="product-badge-user-value-eu"
          >
            <BestChoiceIcon className="shrink-0" />
            <span className={clsx('text-[15px] font-[500]')}>{translations.Badge.countryTopRated}</span>
          </div>
        </div>
      )
    case 'countryPick':
      return (
        <div {...attributes}>
          <div
            className={clsx(
              'z-40 flex h-9 items-center justify-center gap-2 overflow-hidden p-2 text-base font-medium',
            )}
            data-testid="product-badge-user-value-eu"
          >
            <BestChoiceIcon className="shrink-0" />
            <span className={clsx('text-[15px] font-[500]')}>{translations.Badge.countryPick}</span>
          </div>
        </div>
      )
    case 'editorsChoice':
      return (
        <div {...attributes}>
          <div
            className={clsx(
              'z-40 flex h-9 items-center justify-center gap-2 overflow-hidden p-2 text-base font-medium',
            )}
            data-testid="product-badge-user-value-eu"
          >
            <BestChoiceIcon className="shrink-0" />
            <span className={clsx('text-[15px] font-[500]')}>{translations.Badge.editorsChoice}</span>
          </div>
        </div>
      )
    case 'customerFavorite':
      return (
        <div {...attributes}>
          <div
            className={clsx(
              'z-40 flex h-9 items-center justify-center gap-2 overflow-hidden p-2 text-base font-medium',
            )}
            data-testid="product-badge-user-value-eu"
          >
            <HeartIcon className="shrink-0" />
            <span className={clsx('text-[15px] font-[500]')}>{translations.Badge.customerFavorite}</span>
          </div>
        </div>
      )
    case 'countryFavorite':
      return (
        <div {...attributes}>
          <div
            className={clsx(
              'z-40 flex h-9 items-center justify-center gap-2 overflow-hidden p-2 text-base font-medium',
            )}
            data-testid="product-badge-user-value-eu"
          >
            <HeartIcon className="shrink-0" />
            <span className={clsx('text-[15px] font-[500]')}>{translations.Badge.countryFavorite}</span>
          </div>
        </div>
      )
    case 'signaturePick':
      return (
        <div {...attributes}>
          <div
            className={clsx(
              'z-40 flex h-9 items-center justify-center gap-2 overflow-hidden p-2 text-base font-medium',
            )}
            data-testid="product-badge-user-value-eu"
          >
            <ThumbUpSignaturePickIcon className="shrink-0" />
            <span className={clsx('text-[15px] font-[500]')}>{translations.Badge.signaturePick}</span>
          </div>
        </div>
      )
    default:
      return null
  }
}

export default UserValueEUBadge
